module.exports = __webpack_public_path__ + "img/exit.75b289dd.png";